import { observer } from 'mobx-react-lite';

import { toAnswerRows } from './ask-user.utils';
import { AskUserSummary } from './AskUserSummary';

import type { AskUserAnswers } from '@littlebird/sdk';

interface AskUserAnswersSummaryProps {
  answers: AskUserAnswers;
}

export const AskUserAnswersSummary = observer(
  ({ answers }: AskUserAnswersSummaryProps) => {
    const rows = toAnswerRows(answers);
    if (rows.length === 0) return null;

    return <AskUserSummary rows={rows} />;
  }
);
